import util from '../util'

let controller = 'v1/consultas-dict/lotes'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']), {
  ImportarArquivo: function (dto) {
    return util.Axios.Post(controller, dto)
  },
  Baixar: function (codigo) {
    return util.Axios.Get(controller, `${codigo}/download`)
  }
})
